// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609011926/js/" + chunkId + "." + {"44":"91741fd1","225":"4d92a083","481":"324a2504","486":"0dae9e56","770":"4dc40976"}[chunkId] + ".0.5594173342966928.chunk.js";
};